module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "callout callout-info"
  }, [_c('h4', [_vm._v("统计目标主机总量："), _c('span', [_vm._v(_vm._s(_vm.testDeviceList.length))]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("因为数据同步的问题，可能在一段时间内，各个统计部分的总量与目标主机总量不相等。")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "test-device-analysis-data"
  }, [_c('table', {
    staticClass: "test-device-analysis-table"
  }, [_c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.online))])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.offline))])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.nocoap))])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.unregister))])]), _vm._v(" "), _c('tr', {
    staticClass: "test-device-analysis-table-total"
  }, [_c('td', {
    staticClass: "test-device-analysis-table-padding"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.online + _vm.offline + _vm.nocoap + _vm.unregister))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(6), _vm._v(" "), ((_vm.normal + _vm.problem + _vm.nocard) !== 0) ? _c('div', {
    staticClass: "box-body"
  }, [_c('canvas', {
    staticClass: "test-device-analysis-chart",
    attrs: {
      "id": "simCardChart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "test-device-analysis-data"
  }, [_c('table', {
    staticClass: "test-device-analysis-table"
  }, [_c('tr', [_vm._m(7), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.normal))])]), _vm._v(" "), _c('tr', [_vm._m(8), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.problem))])]), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.nocard))])]), _vm._v(" "), _c('tr', {
    staticClass: "test-device-analysis-table-total"
  }, [_c('td', {
    staticClass: "test-device-analysis-table-padding"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v(_vm._s(_vm.normal + _vm.problem + _vm.nocard))])])])])]) : _c('div', {
    staticClass: "box-body"
  }, [_c('p', {
    staticClass: "test-device-analysis-chart-empty"
  }, [_vm._v("There is no data now.")]), _vm._v(" "), _vm._m(10)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Online Data")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart"
  }, [_c('canvas', {
    staticClass: "test-device-analysis-chart",
    attrs: {
      "id": "areaChart"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-check-circle test-device-analysis-table-icon-online"
  }), _vm._v("online")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-times-circle test-device-analysis-table-icon-offline"
  }), _vm._v("offline")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-exclamation-circle test-device-analysis-table-icon-nocoap"
  }), _vm._v("no coap connection")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-minus-circle test-device-analysis-table-icon-unregistered"
  }), _vm._v("unregistered")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-signal"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Sim Card Data")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-check-circle test-device-analysis-table-icon-online"
  }), _vm._v("normal")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-exclamation-circle test-device-analysis-table-icon-offline"
  }), _vm._v("something wrong")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-times-circle test-device-analysis-table-icon-nocoap"
  }), _vm._v("have no card")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "test-device-analysis-data"
  }, [_c('table', {
    staticClass: "test-device-analysis-table"
  }, [_c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-check-circle test-device-analysis-table-icon-online"
  }), _vm._v("normal")]), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-exclamation-circle test-device-analysis-table-icon-offline"
  }), _vm._v("something wrong")]), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-times-circle test-device-analysis-table-icon-nocoap"
  }), _vm._v("have no card")]), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v("-")])]), _vm._v(" "), _c('tr', {
    staticClass: "test-device-analysis-table-total"
  }, [_c('td', {
    staticClass: "test-device-analysis-table-padding"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
    staticClass: "test-device-analysis-table-num"
  }, [_vm._v("-")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c58b9080", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c58b9080"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TestDeviceAnalysis.vue
// module id = 494
// module chunks = 1